import { render, staticRenderFns } from "./AccountInformationPaymentMethod.vue?vue&type=template&id=0a133715&scoped=true&"
import script from "./AccountInformationPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./AccountInformationPaymentMethod.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInformationPaymentMethod.vue?vue&type=style&index=0&id=0a133715&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a133715",
  null
  
)

export default component.exports